<template>
    <img @click="$emit('click', $event)" width="20px" src="../../assets/images/Group 40@2x.png" v-close-popover>
</template>

<script>
export default {
    name: 'CloseIcon'
}
</script>

<style scoped>
    img {
        cursor: pointer;
    }
</style>
